export default "__VITE_ASSET__aw6S8dXR__"